export const PORTFOLIO_MONITORING_DEFAULT_METRICS = [
  {
    key: 'revenue',
    label: 'Revenue EOM prediction',
    higherIsBetter: true,
    greenMinPct: 0,
    amberMinPct: -10,
  },
  {
    key: 'marketing_spend',
    label: 'Marketing spend EOM prediction',
    higherIsBetter: false,
    greenMinPct: 0,
    amberMinPct: 10,
  },
  {
    key: 'cash',
    label: 'Cash',
    higherIsBetter: true,
    greenMinPct: 0,
    amberMinPct: -10,
  },
  {
    key: 'min_cash_balance',
    label: 'Min. cash balance',
    higherIsBetter: true,
    greenMinPct: 10,
    amberMinPct: 0,
  },
  {
    key: 'cohort_m0',
    label: 'Current cohort M0 revenue',
    higherIsBetter: true,
    greenMinPct: 0,
    amberMinPct: -10,
  },
  {
    key: 'cac_change',
    label: 'CAC change',
    higherIsBetter: false,
    greenMinPct: 5,
    amberMinPct: 15,
  },
  {
    key: 'roas_mo_mob_pp',
    label: 'ROAS MO, MOB (PP)',
    higherIsBetter: true,
    greenMinPct: 0,
    amberMinPct: -10,
  },
  {
    key: 'company_score_change',
    label: 'Company score change',
    higherIsBetter: true,
    greenMinPct: -2,
    amberMinPct: -5,
  },
  {
    key: 'current_cac',
    label: 'Current CAC',
    higherIsBetter: false,
    greenMinPct: -10,
    amberMinPct: 0,
  },
  {
    key: 'last_month_cac',
    label: "Last month's CAC",
    higherIsBetter: false,
    greenMinPct: -10,
    amberMinPct: 0,
  },
  {
    key: 'roas_covenant_prediction',
    label: 'ROAS covenant (actual & prediction)',
    higherIsBetter: true,
    greenMinPct: 15,
    amberMinPct: 0,
  },
  {
    key: 'roas_mom',
    label: 'ROAS MoM current month prediction',
    higherIsBetter: true,
    greenMinPct: 10,
    amberMinPct: 0,
  },
  {
    key: 'refund_return_anomalies',
    label: 'Refund and return anomalies',
    higherIsBetter: false,
    greenMinPct: 0,
    amberMinPct: 2,
  },
  {
    key: 'payment_status',
    label: 'Payment status',
    greenMaxDaysLate: 0,
    greenMaxAmountDiffPct: 0,
    amberMaxDaysLate: 7,
    amberMaxAmountDiffPct: 2,
  },
];

export function mergePortfolioMonitoringMetrics(metrics) {
  const byKey = Object.fromEntries((metrics || []).map((metric) => [metric.key, metric]));
  return PORTFOLIO_MONITORING_DEFAULT_METRICS.map((defaults) => ({
    ...defaults,
    ...(byKey[defaults.key] || {}),
    label: byKey[defaults.key]?.label || defaults.label,
  }));
}
